import React, { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Asset/logo.jpg";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Contact Us", path: "/contact-us" },
  ];

  const getLinkClass = (path) =>
    location.pathname === path
      ? "text-[#b7b7a1] font-semibold border-b-2 border-[#b7b7a1]"
      : "hover:text-[#b7b7a1]";

  return (
    <header className="bg-white shadow-md py-4 px-6 flex justify-between items-center relative">
      {/* Logo and Title */}
      <div className="flex items-center space-x-3">
        <img src={logo} alt="CBS Logo" className="w-24 h-16 object-contain" />
        <h1 className="text-xl sm:text-3xl font-semibold text-gray-800">
          Charethri Business Solutions
        </h1>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex space-x-6 text-gray-800 font-medium">
        {navItems.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className={getLinkClass(item.path)}
          >
            {item.name}
          </Link>
        ))}
      </nav>

      {/* Mobile Menu Button */}
      <button className="md:hidden text-gray-800" onClick={() => setMenuOpen(true)}>
        <Menu size={28} />
      </button>

      {/* Mobile Navigation Panel */}
      {menuOpen && (
        <div className="fixed inset-0 bg-black/40 z-50" onClick={() => setMenuOpen(false)}>
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            className="fixed top-0 right-0 w-2/3 sm:w-1/2 h-full bg-white shadow-lg flex flex-col items-center pt-20 space-y-6 text-lg font-medium text-gray-800 z-50"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button className="absolute top-5 right-5 text-gray-800" onClick={() => setMenuOpen(false)}>
              <X size={28} />
            </button>

            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={getLinkClass(item.path)}
                onClick={() => setMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </motion.div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
